import React from 'react'

const CopyIcon = ({ className, size = 21, currentColor = '#4F46E5' }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         className={className}
         width={size}
         height={size}
         viewBox={`0 0 ${size} ${size}`}
         fill={currentColor}>
         <path d="M7.5 15.765C7.04167 15.765 6.64931 15.6018 6.32292 15.2754C5.99653 14.949 5.83333 14.5566 5.83333 14.0983V4.09831C5.83333 3.63997 5.99653 3.24761 6.32292 2.92122C6.64931 2.59484 7.04167 2.43164 7.5 2.43164H15C15.4583 2.43164 15.8507 2.59484 16.1771 2.92122C16.5035 3.24761 16.6667 3.63997 16.6667 4.09831V14.0983C16.6667 14.5566 16.5035 14.949 16.1771 15.2754C15.8507 15.6018 15.4583 15.765 15 15.765H7.5ZM7.5 14.0983H15V4.09831H7.5V14.0983ZM4.16667 19.0983C3.70833 19.0983 3.31597 18.9351 2.98958 18.6087C2.66319 18.2823 2.5 17.89 2.5 17.4316V6.59831C2.5 6.3622 2.57986 6.16428 2.73958 6.00456C2.89931 5.84484 3.09722 5.76497 3.33333 5.76497C3.56944 5.76497 3.76736 5.84484 3.92708 6.00456C4.08681 6.16428 4.16667 6.3622 4.16667 6.59831V17.4316H12.5C12.7361 17.4316 12.934 17.5115 13.0938 17.6712C13.2535 17.8309 13.3333 18.0289 13.3333 18.265C13.3333 18.5011 13.2535 18.699 13.0938 18.8587C12.934 19.0184 12.7361 19.0983 12.5 19.0983H4.16667Z" fill={currentColor}/>
      </svg>
   )
}

export default CopyIcon
